import React from 'react';
import { useNavigate } from 'react-router-dom';

const TabMenuNav = ({ menu, type, onTypeClick }) => {
    const history = useNavigate();
    return (
        <div className='admin-navbar'>
            <button className='admin-home' onClick={() => history('/')}></button>
            <ul className='admin-gnb'>
                {menu.map(({ id, title }) => (
                    <li key={id} className={type === id ? 'selected' : ''} onClick={() => onTypeClick(id)}>
                        {title}
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default TabMenuNav;